import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./ResponsiveBottomNav.css";

const STORAGE_KEY = "responsive_bottom_nav_config_v1";
const MAX_ITEMS = 3;
const ROUTES = {
    principal: { path: "/principal", label: "Inicio", icon: "bx-home-alt", section: "inicio" },
    trafico: { path: "/trafico", label: "Tráfico", icon: "bxs-truck", section: "operaciones" },
    mapCenter: { path: "/mapCenter", label: "Mapa", icon: "bx-map-alt", section: "operaciones" },
    solicitudes: { path: "/solicitudes", label: "Solicitudes", icon: "bx-file", section: "operaciones" },
    historico: { path: "/historico", label: "Histórico", icon: "bx-history", section: "operaciones" },
    reportes: { path: "/reportes", label: "Reportes", icon: "bx-bar-chart-alt-2", section: "reportes" },
    usuarios: { path: "/usuarios", label: "Usuarios", icon: "bx-group", section: "administracion" },
    roles: { path: "/roles", label: "Roles", icon: "bx-shield-quarter", section: "administracion" },
    myprofile: { path: "/myprofile", label: "Perfil", icon: "bx-user", section: "cuenta" },
};

const DEFAULTS = {
    inicio: ["principal", "trafico", "mapCenter"],
    operaciones: ["principal", "trafico", "mapCenter"],
    reportes: ["principal", "reportes", "trafico"],
    administracion: ["principal", "usuarios", "roles"],
    cuenta: ["principal", "myprofile", "trafico"],
};

const getSection = (pathname) => {
    if (pathname === "/principal") return "inicio";
    const route = Object.values(ROUTES).find((item) => item.path === pathname);
    return route?.section || "operaciones";
};

const readConfig = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return stored && typeof stored === "object" ? stored : {};
    } catch {
        return {};
    }
};

const ResponsiveBottomNav = () => {
    const { pathname } = useLocation();
    const section = getSection(pathname);
    const [config] = useState(readConfig);
    const selectedKeys = (config[section] || DEFAULTS[section] || DEFAULTS.operaciones)
        .filter((key, index, values) => ROUTES[key] && values.indexOf(key) === index)
        .slice(0, MAX_ITEMS);

    const hasLocalMenuButton = ["/principal", "/trafico", "/trafico_por_recoger", "/trafico_oculto", "/solicitudes", "/mapCenter", "/geocercas2", "/controldevice", "/controldevices", "/roles", "/usuarios", "/empresas"].includes(pathname);
    const togglePlatformMenu = () => document.querySelector('[class*="sidenav-toggle"]')?.click();

    return (
        <>
            {!hasLocalMenuButton && (
                <button
                    type="button"
                    className="responsive-platform-menu-toggle"
                    onClick={togglePlatformMenu}
                    aria-label="Abrir menú de navegación"
                    title="Menú de navegación"
                >
                    <i className="bx bx-menu" aria-hidden="true" />
                </button>
            )}
            <nav className="trafico-mobile-bottom-nav responsive-bottom-nav" aria-label="Accesos rápidos">
                {selectedKeys.map((key) => {
                    const route = ROUTES[key];
                    return <a key={key} href={route.path} className={pathname === route.path ? "active" : undefined} aria-current={pathname === route.path ? "page" : undefined}><i className={`bx ${route.icon}`} aria-hidden="true" /><span>{route.label}</span></a>;
                })}
                <button type="button" onClick={togglePlatformMenu} aria-label="Abrir menú de navegación" title="Menú de navegación">
                    <i className="bx bx-dots-horizontal-rounded" aria-hidden="true" /><span>Más</span>
                </button>
            </nav>
        </>
    );
};

export default ResponsiveBottomNav;
